var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerdIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87923 0H0L4.1559 12H13.2241C13.8878 11.99 14.5781 11.8619 14.9547 11.7337C17.1513 10.9905 18.9456 8.95093 18.9456 4.13731C18.9456 1.192 21.3639 0.883842 22 0.601312V0H8.87923Z",
    fill: "#37995D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0V0.601312C21.3639 0.883842 18.9456 1.192 18.9456 4.13731C18.9456 8.95156 17.1507 10.9911 14.9541 11.7343C14.5781 11.8619 13.8878 11.99 13.2241 11.9994L4.15653 12L2.96625 8.56277H11.467L11.1641 7.68768H2.6627L1.49383 4.31232H9.99456L9.69164 3.43723H1.19028L0 0H22Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerdIcon);
export default __webpack_public_path__ + "static/media/verd-icon.3b91509593a3da315cd8f7981b94dff2.svg";
export { ForwardRef as ReactComponent };